// extracted by mini-css-extract-plugin
module.exports = {"container":"noteToPrint_container__iyqbR","logo":"noteToPrint_logo__XK3Hg","title":"noteToPrint_title__DpOd1","printedBodyClass":"noteToPrint_printedBodyClass__p6mpk"};